// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "c85cdc9",
    "hash": "c85cdc9",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c85cdc9",
    "semverString": null,
    "version": "1.0.10"
};
/* tslint:enable */
